(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDetailController', EventFormCategoryDetailController);

    EventFormCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'EventFormCategory'];

    function EventFormCategoryDetailController($scope, $rootScope, $stateParams, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.subCategoryHistoryById = {};
        vm.toggleSubCategoryHistory = toggleSubCategoryHistory;
        
        EventFormCategory.queryListSubCategoryInclDeleted({id: $stateParams.id}, function(result) {
        	vm.EventFormCategory.listEventFormSubCategory =   result;
        	normalizeSubCategories(vm.EventFormCategory.listEventFormSubCategory);
           
        });

        vm.load = function (id) {
            EventFormCategory.get({id: id}, function(result) {
                vm.EventFormCategory = result;
                EventFormCategory.getListSubCategory({id: id}, function(result) {
                	vm.EventFormCategory.listEventFormSubCategory =   result;
                    normalizeSubCategories(vm.EventFormCategory.listEventFormSubCategory);
                });
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:EventFormCategoryUpdate', function(event, result) {
            vm.EventFormCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function toggleSubCategoryHistory(subCategory) {
            if (!subCategory || !subCategory.id) {
                return;
            }
            if (subCategory.showHistory) {
                subCategory.showHistory = false;
                return;
            }
            if (vm.subCategoryHistoryById[subCategory.id]) {
                subCategory.showHistory = true;
                return;
            }
            EventFormCategory.getSubCategoryHistory({id: subCategory.id}, function(result) {
                normalizeSubCategories(result);
                vm.subCategoryHistoryById[subCategory.id] = result;
                subCategory.showHistory = true;
            });
        }

        function normalizeSubCategories(subCategories) {
            angular.forEach(subCategories || [], function(subCategory) {
                if (!subCategory || !subCategory.customFields) {
                    return;
                }
                try {
                    subCategory.customFields = JSON.parse(subCategory.customFields);
                } catch (e) {
                    console.log(e);
                }
            });
        }

    }
})();
